import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CampConfigurationService } from '../service/camp-configuration.service';
import { LABEL_KEY_END_INDICATOR, LABEL_KEY_START_INDICATOR, FRENCH_CHARECTERS_HTML_CODES } from '../constant/constant';
import * as _ from 'lodash';

export function getMatTabGroupSelectedIndex(matTabGroup: MatTabGroup, targetTab: string) {
  if(matTabGroup && targetTab) {
    let count = 0;
    let selectedIndex = 0;
    const queryList = matTabGroup._tabs ? matTabGroup._tabs : [];
    queryList.forEach((matTab: MatTab) => {
      if(matTab.ariaLabel === targetTab) {
        selectedIndex = count;
        return;
      }
      count++;
    });
    return selectedIndex;
  }
  return 0;
}

export function translateSurveyJS(campConfigurationService: CampConfigurationService, surveyjsJson: object) {
  const translatedSurveyJson = _.mergeWith({}, surveyjsJson,
    (a, b) => {
      if (typeof b === 'string') {
        const regexExp = new RegExp(`${LABEL_KEY_START_INDICATOR}.*${LABEL_KEY_END_INDICATOR}`, 'g');
        const matches = b.match(regexExp);
        let res = b.valueOf();
        if (matches) {
          matches.forEach(match => {
            const startIndex = match.indexOf(LABEL_KEY_START_INDICATOR);
            const subString = match.substr(LABEL_KEY_START_INDICATOR.length - startIndex);

            const endIndex = subString.indexOf(LABEL_KEY_END_INDICATOR);
            const labelKey = subString.substr(0, endIndex);
            const labelValue = campConfigurationService.getLabelByKey(labelKey);
            res = res.replace(match, labelValue);
          });
          return res;
        }
      }
    });
  return translatedSurveyJson;
}

export function replaceFrenchCharecterByHTMLCode(frenchCharecter: string) {

  const record = FRENCH_CHARECTERS_HTML_CODES.find(record => record.charecter == frenchCharecter);
  if(record) return record.htmlCode;
  else return '';
}

